<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import WrMinus from "../atoms/icons/WrMinus.vue";
import WrPlus from "../atoms/icons/WrPlus.vue";

const props = defineProps({
  Content: {
    type: Array,
    default: [],
  },
  variantTwo: {
    type: Boolean,
    default: false,
  },
  headingClass: {
    type: String,
    default: "",
  },
});
const content: any = computed(() => props.Content);
</script>

<template>
  <Accordion class="w-full" :value="['0']" multiple>
    <template v-if="props.variantTwo" #collapseicon>
      <span
        :class="
          props.variantTwo
            ? 'text-[#4F0088] dark:text-[#AF66E4] bg-[#ECECEC] dark:bg-[#1B043B] size-12 p-3.5 rounded-full'
            : '!text-[#4F0088] dark:!text-[#E2BBFF] '
        "
      >
        <WrMinus />
      </span>
    </template>

    <template v-if="props.variantTwo" #expandicon>
      <span
        :class="
          props.variantTwo
            ? 'text-[#4F0088] dark:text-[#AF66E4] bg-[#ECECEC] dark:bg-[#1B043B] size-12 p-3.5 rounded-full'
            : '!text-[#4F0088] dark:!text-[#E2BBFF] '
        "
      >
        <WrPlus />
      </span>
    </template>
    <div
      v-for="(content, index) in content"
      :key="index"
      class="mb-2 last:mb-0 rounded-lg border-0 p-px w-full bg-[var(--border-accordion)] dark:bg-[image:var(--border-accordion)] overflow-hidden"
    >
      <div class="bg-[image:var(--bg-accordion)] rounded-lg">
        <AccordionPanel
          :value="index.toString()"
          class="mb-2 last:mb-0 rounded-lg border-0"
        >
          <AccordionHeader
            :pt="{
              content: { class: '!bg-transparent' },
              toggleicon: {
                class: 'dark:!text-[#E2BBFF] shrink-0',
              },
            }"
            :class="
              twMerge(
                'tracking-[0.5px] !font-medium max-w-[95%] rounded-lg !bg-transparent hover:!bg-transparent pl-5',
                props.headingClass
              )
            "
          >
            {{ content.title }}</AccordionHeader
          >
          <AccordionContent
            :pt="{ content: { class: '!bg-transparent' } }"
            class="!bg-transparent rounded-b-lg !font-normal"
          >
            <div
              class="m-0 tracking-[0.5px]"
              v-html="content.description"
            ></div>
          </AccordionContent>
        </AccordionPanel>
      </div>
    </div>
  </Accordion>
</template>
